<template>
  <TarjetaDatos titulo="Características Vivienda">
    <Campo2L :valor="poliza.ubicacionVivienda" etiqueta="Ubicación Vivienda" />
    <Campo2L :valor="poliza.tipoVivienda" etiqueta="Tipo Vivienda" />
    <Campo2L :valor="poliza.usoVivienda" etiqueta="Uso Vivienda" />
    <Campo2L :valor="poliza.regimenVivienda" etiqueta="Régimen Vivienda" />
    <Campo2L :valor="poliza.anyoConstruccion" etiqueta="Año Construcción" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
